import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "errors"]
  static values = { frameId: { type: String, default: "user-edit-modal-frame" } }

  connect() {
    this.boundOnFrameRender = this.onFrameRender.bind(this)
    this.boundOnBeforeStreamRender = this.onBeforeStreamRender.bind(this)
    document.addEventListener("turbo:frame-render", this.boundOnFrameRender)
    document.addEventListener("turbo:before-stream-render", this.boundOnBeforeStreamRender)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.boundOnFrameRender)
    document.removeEventListener("turbo:before-stream-render", this.boundOnBeforeStreamRender)
  }

  onFrameRender(event) {
    if (event.target.id !== this.frameIdValue) return
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  onBeforeStreamRender(event) {
    const stream = event.target
    if (!(stream instanceof Element)) return
    if (stream.getAttribute("target") !== this.frameIdValue) return

    const defaultRender = event.detail.render
    event.detail.render = (currentElement) => {
      defaultRender(currentElement)
      this.reopenDialogFromFrame()
    }
  }

  open(event) {
    const row = event.currentTarget
    const editUrl = row.dataset.editUrl
    if (!editUrl) return

    this.clearErrors()
    Turbo.visit(editUrl, { frame: this.frameIdValue })
  }

  openNew() {
    this.clearErrors()
    Turbo.visit("/users/new", { frame: this.frameIdValue })
  }

  openDeleteConfirmation(event) {
    const modalId = event.currentTarget.dataset.deleteModalId
    if (!modalId) return

    const modal = document.getElementById(modalId)
    if (modal) modal.showModal()
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  clearErrors() {
    if (!this.hasErrorsTarget) return

    this.errorsTarget.textContent = ""
    this.errorsTarget.classList.add("hidden")
  }

  reopenDialogFromFrame() {
    requestAnimationFrame(() => {
      const frame = document.getElementById(this.frameIdValue)
      const dialog = frame?.querySelector("dialog")
      if (dialog && !dialog.open) dialog.showModal()
    })
  }
}
